import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment.staging';


@Injectable({ providedIn: 'root' })
export class MyTeamsAccessGuard implements CanActivate {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isNewVersion = localStorage.getItem('isMyTeamsNewVersion');
    if (isNewVersion === "true") {
      const currentPath = state.url.startsWith("/") ? state.url : "/" + state.url;
      const redirectUrl = `${environment.NEW_SITE_URL}${currentPath}`;
      window.location.href = redirectUrl;
      return false;
    } else {
      return true;
    }
  }
}
